module.exports = __webpack_public_path__ + "img/40_38_049_560.44dc5478.jpg";